(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    /* ===== Department disclosure helpers ===== */
    function openDept(btn, panel) {
      btn.setAttribute('aria-expanded', 'true');
      panel.removeAttribute('hidden');
    }

    function closeDept(btn, panel) {
      btn.setAttribute('aria-expanded', 'false');
      panel.setAttribute('hidden', '');
    }

    function closeAllDepts() {
      document.querySelectorAll('[data-petz-dept-toggle][aria-expanded="true"]').forEach(function (btn) {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) closeDept(btn, panel);
      });
    }

    function initDeptToggles(root) {
      (root || document).querySelectorAll('[data-petz-dept-toggle]').forEach(function (btn) {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel && btn.getAttribute('aria-expanded') !== 'true') {
          panel.setAttribute('hidden', '');
        }
      });
    }

    /* ===== Focusable elements inside a container ===== */
    function getFocusable(container) {
      return Array.from(container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (el) {
        return el.offsetParent !== null;
      });
    }

    /* ===== Focus trap inside an element ===== */
    function trapFocus(container, event) {
      var focusable = getFocusable(container);
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    /* ===== Drawer state management ===== */
    function openDrawer(drawer, toggle) {
      drawer.setAttribute('aria-hidden', 'false');
      /* Sync all toggles that control this drawer */
      document.querySelectorAll('[data-petz-drawer-toggle][aria-controls="' + drawer.id + '"]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'true');
        var closeLabel = t.getAttribute('data-close-label');
        if (closeLabel) t.setAttribute('aria-label', closeLabel);
      });
      document.body.style.overflow = 'hidden';
      var panel = drawer.querySelector('[data-petz-nav-drawer-panel]');
      if (panel) {
        var focusable = getFocusable(panel);
        if (focusable.length) focusable[0].focus();
      }
    }

    function closeDrawer(drawer, toggle) {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      /* Sync all toggles that control this drawer */
      document.querySelectorAll('[data-petz-drawer-toggle][aria-controls="' + drawer.id + '"]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        var openLabel = t.getAttribute('data-open-label');
        if (openLabel) t.setAttribute('aria-label', openLabel);
      });
      if (toggle) toggle.focus();
    }

    function findToggleForDrawer(drawerId) {
      return document.querySelector(
        '[data-petz-drawer-toggle][aria-controls="' + drawerId + '"]'
      );
    }

    /* ===== Submenu disclosure helpers ===== */
    function closeSubmenu(toggle) {
      var submenu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!submenu) return;
      toggle.setAttribute('aria-expanded', 'false');
      submenu.setAttribute('data-collapsed', 'true');
      var label = toggle.querySelector('[data-petz-nav-toggle-label]');
      if (label) label.textContent = label.getAttribute('data-open-text') || label.textContent;
    }

    /* Deep-close: collapses toggle's submenu AND resets all nested disclosure controls. */
    function closeSubmenuDeep(toggle) {
      var submenu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!submenu) return;
      toggle.setAttribute('aria-expanded', 'false');
      submenu.setAttribute('data-collapsed', 'true');
      var label = toggle.querySelector('[data-petz-nav-toggle-label]');
      if (label) label.textContent = label.getAttribute('data-open-text') || label.textContent;
      submenu.querySelectorAll('[data-petz-nav-toggle]').forEach(function (child) {
        child.setAttribute('aria-expanded', 'false');
        var childSub = document.getElementById(child.getAttribute('aria-controls'));
        if (childSub) childSub.setAttribute('data-collapsed', 'true');
        var childLabel = child.querySelector('[data-petz-nav-toggle-label]');
        if (childLabel) childLabel.textContent = childLabel.getAttribute('data-open-text') || childLabel.textContent;
      });
    }

    function openSubmenu(toggle) {
      var submenu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!submenu) return;
      toggle.setAttribute('aria-expanded', 'true');
      submenu.removeAttribute('data-collapsed');
      var label = toggle.querySelector('[data-petz-nav-toggle-label]');
      if (label) label.textContent = label.getAttribute('data-close-text') || label.textContent;
    }

    /* Close all sibling items at the same level, resetting their descendants. */
    function closeSiblingSubmenus(toggle) {
      var item = toggle.closest('.petz-nav__item');
      var list = item ? item.parentElement : null;
      if (!list) return;
      list.querySelectorAll(
        ':scope > .petz-nav__item > .petz-nav__row > [data-petz-nav-toggle][aria-expanded="true"]'
      ).forEach(function (sibling) {
        if (sibling !== toggle) closeSubmenuDeep(sibling);
      });
    }

    /* ===== Desktop mega-panel helpers (navbar only) ===== */
    function openMegaPanel(item, navbar) {
      var toggle = item.querySelector(':scope > .petz-nav__row > [data-petz-nav-toggle]');
      if (!toggle) return;
      /* Close any other open mega panel first */
      navbar.querySelectorAll('.petz-nav__item--level-1[data-petz-mega-open]').forEach(function (sib) {
        if (sib !== item) {
          var sibToggle = sib.querySelector(':scope > .petz-nav__row > [data-petz-nav-toggle]');
          if (sibToggle) closeSubmenu(sibToggle);
          sib.removeAttribute('data-petz-mega-open');
        }
      });
      openSubmenu(toggle);
      item.setAttribute('data-petz-mega-open', '');
    }

    function closeMegaPanel(item) {
      var toggle = item.querySelector(':scope > .petz-nav__row > [data-petz-nav-toggle]');
      if (toggle) closeSubmenu(toggle);
      item.removeAttribute('data-petz-mega-open');
    }

    /* ===== Header + drawer initialization ===== */
    function initDrawer(drawer) {
      drawer.setAttribute('data-petz-nav-enhanced', '');
      drawer.querySelectorAll('[data-petz-nav-toggle]').forEach(closeSubmenu);
    }

    function initHeader(header) {
      header.setAttribute('data-petz-nav-enhanced', '');
      header.querySelectorAll('[data-petz-nav-toggle]').forEach(closeSubmenu);
      /* Mark associated drawer as enhanced so its submenu toggles become visible. */
      var drawerToggle = header.querySelector('[data-petz-drawer-toggle]');
      if (drawerToggle) {
        var drawer = document.getElementById(drawerToggle.getAttribute('aria-controls'));
        if (drawer) initDrawer(drawer);
      }
      /* Desktop navbar: open mega panel on pointer/focus, close on leave/blur */
      var navbar = header.querySelector('[data-petz-header-nav]');
      if (navbar) {
        navbar.querySelectorAll('.petz-nav__item--level-1').forEach(function (item) {
          var panel = item.querySelector(':scope > .petz-nav__submenu--level-1');
          if (!panel) return; /* leaf item (no submenu) */
          item.addEventListener('pointerenter', function () { openMegaPanel(item, navbar); });
          item.addEventListener('pointerleave', function () { closeMegaPanel(item); });
          item.addEventListener('focusin', function () { openMegaPanel(item, navbar); });
          item.addEventListener('focusout', function (e) {
            if (!item.contains(e.relatedTarget)) closeMegaPanel(item);
          });
        });
      }
    }

    document.querySelectorAll('[data-petz-header]').forEach(initHeader);
    initDeptToggles();

    /* ===== Delegated click handler ===== */
    document.addEventListener('click', function (event) {
      /* Department disclosure toggle */
      var deptToggle = event.target.closest('[data-petz-dept-toggle]');
      if (deptToggle) {
        var deptPanel = document.getElementById(deptToggle.getAttribute('aria-controls'));
        if (deptPanel) {
          if (deptToggle.getAttribute('aria-expanded') === 'true') {
            closeDept(deptToggle, deptPanel);
          } else {
            closeAllDepts();
            openDept(deptToggle, deptPanel);
          }
        }
        return;
      }

      /* Department option selection */
      var deptBtn = event.target.closest('[data-petz-dept-btn]');
      if (deptBtn) {
        var deptValue = deptBtn.getAttribute('data-petz-dept-value');
        var deptLabel = deptBtn.textContent.trim();
        var deptArea = deptBtn.closest('.petz-header__dept');

        /* Update aria-pressed on all option buttons in this dept area */
        if (deptArea) {
          deptArea.querySelectorAll('[data-petz-dept-btn]').forEach(function (b) {
            b.setAttribute('aria-pressed', String(b === deptBtn));
          });
        }

        /* Update toggle button label */
        var toggleBtn = deptArea ? deptArea.querySelector('[data-petz-dept-toggle]') : null;
        var labelSpan = toggleBtn ? toggleBtn.querySelector('[data-petz-dept-label]') : null;
        if (labelSpan) labelSpan.textContent = deptLabel;

        /* Update hidden filter input in adjacent search form */
        var searchShell = deptArea ? deptArea.closest('.petz-header__search-shell') : null;
        var deptInput = searchShell ? searchShell.querySelector('[data-petz-dept-input]') : null;
        if (deptInput) {
          if (deptValue) {
            /* Shopify's own Product-metafield filter parameter — the same native
               contract the main Search results page reads. */
            deptInput.setAttribute('name', 'filter.p.m.custom.pet_department_' + deptValue.replace(/-/g, '_'));
            deptInput.value = '1';
          } else {
            deptInput.removeAttribute('name');
            deptInput.value = '';
          }
        }

        /* Close panel and return focus to toggle button */
        if (toggleBtn) {
          var deptPanel = document.getElementById(toggleBtn.getAttribute('aria-controls'));
          if (deptPanel) closeDept(toggleBtn, deptPanel);
          toggleBtn.focus();
        }
        return;
      }

      /* Close dept panel when clicking outside dept area */
      if (!event.target.closest('.petz-header__dept')) {
        closeAllDepts();
      }

      /* Dock search button: focus the header search input */
      var dockSearchBtn = event.target.closest('[data-petz-dock-search]');
      if (dockSearchBtn) {
        var headerEl = dockSearchBtn.closest('[data-petz-header]');
        if (headerEl) {
          var searchInput = headerEl.querySelector('.petz-search-form__input');
          if (searchInput) searchInput.focus();
        }
        return;
      }

      /* Drawer toggle (mobile hamburger) */
      var drawerToggle = event.target.closest('[data-petz-drawer-toggle]');
      if (drawerToggle) {
        var drawerId = drawerToggle.getAttribute('aria-controls');
        var drawer = document.getElementById(drawerId);
        if (drawer) {
          if (drawer.getAttribute('aria-hidden') === 'false') {
            closeDrawer(drawer, drawerToggle);
          } else {
            openDrawer(drawer, drawerToggle);
          }
        }
        return;
      }

      /* Drawer close button (inside panel) */
      var closeBtn = event.target.closest('[data-petz-drawer-close]');
      if (closeBtn) {
        var drawerEl = closeBtn.closest('[data-petz-nav-drawer]');
        if (drawerEl) {
          var toggle = findToggleForDrawer(drawerEl.id);
          closeDrawer(drawerEl, toggle);
        }
        return;
      }

      /* Drawer backdrop click */
      if (event.target.closest('[data-petz-nav-drawer-backdrop]')) {
        var drawerEl2 = event.target.closest('[data-petz-nav-drawer]');
        if (drawerEl2) {
          var toggle2 = findToggleForDrawer(drawerEl2.id);
          closeDrawer(drawerEl2, toggle2);
        }
        return;
      }

      /* Submenu disclosure toggle (drawer accordion — desktop level-1 toggle is hidden) */
      var submenuToggle = event.target.closest('[data-petz-nav-toggle]');
      if (submenuToggle) {
        if (submenuToggle.getAttribute('aria-expanded') === 'true') {
          closeSubmenuDeep(submenuToggle);
        } else {
          closeSiblingSubmenus(submenuToggle);
          openSubmenu(submenuToggle);
        }
        return;
      }

      /* Click outside navbar: close any open desktop mega panel */
      if (!event.target.closest('[data-petz-header-nav]')) {
        document.querySelectorAll(
          '[data-petz-header-nav] [data-petz-nav-toggle][aria-expanded="true"]'
        ).forEach(closeSubmenu);
        document.querySelectorAll(
          '[data-petz-header-nav] .petz-nav__item--level-1[data-petz-mega-open]'
        ).forEach(closeMegaPanel);
      }
    });

    /* ===== Keyboard handling ===== */
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        /* Close open dept panel first — return focus to dept button */
        var openDeptBtn = document.querySelector('[data-petz-dept-toggle][aria-expanded="true"]');
        if (openDeptBtn) {
          var openDeptPanel = document.getElementById(openDeptBtn.getAttribute('aria-controls'));
          if (openDeptPanel) closeDept(openDeptBtn, openDeptPanel);
          openDeptBtn.focus();
          return;
        }

        /* Restore visible anchor focus before closing; focusin may open the panel. */
        var openMega = document.querySelector('[data-petz-header-nav] .petz-nav__item--level-1[data-petz-mega-open]');
        if (openMega) {
          var megaAnchor = openMega.querySelector(':scope > .petz-nav__row > a.petz-nav__link');
          if (megaAnchor) megaAnchor.focus();
          closeMegaPanel(openMega);
          return;
        }
        /* Close open drawer */
        var openDrawerEl = document.querySelector('[data-petz-nav-drawer][aria-hidden="false"]');
        if (openDrawerEl) {
          var toggle = findToggleForDrawer(openDrawerEl.id);
          closeDrawer(openDrawerEl, toggle);
          return;
        }
        /* Close innermost expanded submenu (drawer accordions) */
        var active = document.activeElement;
        if (!active || !active.closest) return;
        var item = active.closest('.petz-nav__item');
        while (item) {
          var toggle2 = item.querySelector(
            ':scope > .petz-nav__row > [data-petz-nav-toggle][aria-expanded="true"]'
          );
          if (toggle2) {
            closeSubmenu(toggle2);
            toggle2.focus();
            return;
          }
          item = item.parentElement ? item.parentElement.closest('.petz-nav__item') : null;
        }
        return;
      }

      /* Focus trap while drawer is open */
      if (event.key === 'Tab') {
        var activeDrawer = document.querySelector('[data-petz-nav-drawer][aria-hidden="false"]');
        if (activeDrawer) {
          var panel = activeDrawer.querySelector('[data-petz-nav-drawer-panel]');
          if (panel) trapFocus(panel, event);
        }
      }
    });

    /* ===== Theme editor section reload ===== */
    document.addEventListener('shopify:section:load', function (event) {
      var header = event.target.querySelector('[data-petz-header]');
      if (header) initHeader(header);
      initDeptToggles(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var drawer = event.target.querySelector('[data-petz-nav-drawer]');
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-collections-directory"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var petzLcDirControllers = {};

    function initPetzLcDirectory(section) {
      var sectionId = section.dataset.petzLcDirectoryId;
      if (!sectionId) return;

      if (petzLcDirControllers[sectionId]) {
        petzLcDirControllers[sectionId].abort();
      }
      var controller = new AbortController();
      petzLcDirControllers[sectionId] = controller;
      var opts = { signal: controller.signal };

      var input = section.querySelector('[data-petz-lc-directory-search]');
      var groups = Array.from(section.querySelectorAll('[data-petz-lc-directory-group]'));
      var statusEl = section.querySelector('[data-petz-lc-directory-status]');
      var clearBtn = section.querySelector('[data-petz-lc-directory-clear]');
      var searchWrap = section.querySelector('[data-petz-lc-directory-search-wrap]');

      var locale = section.dataset.locale || 'en';
      var pluralRules = new Intl.PluralRules(locale);
      var tmplMap = {
        zero: section.dataset.tmplZero || '',
        one: section.dataset.tmplOne || '',
        two: section.dataset.tmplTwo || '',
        few: section.dataset.tmplFew || '',
        many: section.dataset.tmplMany || '',
        other: section.dataset.tmplOther || ''
      };
      var tmplNoResults = section.dataset.tmplNoResults || '';

      function filter() {
        if (!input) return;
        var rawQuery = input.value.trim();
        var query = rawQuery.toLowerCase();
        var links = Array.from(section.querySelectorAll('[data-petz-lc-directory-group-nav] a'));
        var visible = 0;

        links.forEach(function (link) {
          var match = !query || link.textContent.toLowerCase().indexOf(query) !== -1;
          link.hidden = !match;
          if (match) visible++;
        });

        groups.forEach(function (group) {
          group.hidden = !!query && !Array.from(group.querySelectorAll('[data-petz-lc-directory-group-nav] a')).some(function (a) { return !a.hidden; });
        });

        if (statusEl) {
          if (query) {
            var tmpl = visible === 0 ? tmplNoResults : (tmplMap[pluralRules.select(visible)] || tmplMap.other);
            statusEl.textContent = tmpl.replace('{count}', String(visible)).replace('{query}', '⁨' + rawQuery + '⁩');
          } else {
            statusEl.textContent = '';
          }
        }

        if (clearBtn) clearBtn.hidden = !query;
      }

      if (searchWrap) searchWrap.removeAttribute('hidden');
      section.setAttribute('data-petz-lc-directory-enhanced', '');

      if (input) input.addEventListener('input', filter, opts);

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          if (!input) return;
          input.value = '';
          filter();
          input.focus();
        }, opts);
      }
    }

    document.querySelectorAll('[data-petz-lc-directory-id]').forEach(initPetzLcDirectory);

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-petz-lc-directory-id]');
      if (section) initPetzLcDirectory(section);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var section = event.target.querySelector('[data-petz-lc-directory-id]');
      if (!section) return;
      var id = section.dataset.petzLcDirectoryId;
      if (id && petzLcDirControllers[id]) {
        petzLcDirControllers[id].abort();
        delete petzLcDirControllers[id];
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
